import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withLocalize } from "react-localize-redux";
import { Notification, Space } from '@mantine/core';
import QuaterlyReportList from '../quaterlyreport/QuaterlyReportList';
import history from '../../history';
import { createQuaterlyReport} from '../../actions/quaterlyReport';

import Progress from '../partials/Progress'
import ContainerTranslation from "../partials/ContainerTranslation";
import ExtractorPowerPoint from '../partials/ExportPowerPoint';

import { fetchProject,uploadPicture } from '../../actions/project'

class ProjectView extends React.Component {

  fourth = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      popUpShowExtensionError: false,
      isPopupOpen: false
    }
    this.props.fetchProject(this.props.match.params.id);
  }

  handleClose = () => {
    this.setState({ popUpShowExtensionError: false });
  };

  componentDidUpdate(){
    if (this.props.quaterlyReportMessage === 'Created QuaterlyReport' && this.props.quaterlyReport && this.props.quaterlyReport._id) {
      history.push({
        pathname: '/quaterlyReport/edit/' + this.props.quaterlyReport._id
      });
    }

  }

  togglePopup() {

    if (this.state.isPopupOpen) {
      this.setState({ isPopupOpen: false })
    }
    else {
      this.setState({ isPopupOpen: true })
    }
  }

  uploadPicture(files) {
    if (files[0]) {
      const acceptedExtensions = [".png", ".jpg", ".jpeg"];
      const extension = files[0].name.substring(files[0].name.lastIndexOf("."));
      const isValidExtension = acceptedExtensions.find((m) => m === extension) != null;
      if(isValidExtension){
        this.setState({ popUpShowExtensionError: false });
        this.props.uploadPicture(files[0], this.props.match.params.id)
      } else {
        this.setState({ popUpShowExtensionError: true });
      }
    }
  }


    truncate(path) {
        const maxChar = 60;

        let name = [];

        if (path.length === 1) {
            return path[0].length > maxChar ? [`... ${path[0].slice(0, maxChar)}`] : path
        }

        name = path.reduceRight((name, level) => {
            if (name[0] === "...") {
                return name
            }
            if (name.reduce((length, x) => length + x.length, 0) + level.length > maxChar) {
                name.unshift("...")
                return name
            }
            name.unshift(level)
            return name
        }, [])
        return name
    }


  render() {

    if (this.props.project === undefined || this.props.project.authorization === undefined) {
      return null
    }

    const route = this.props.project.authorization.write ? "/project/edit/" + this.props.project._id : null

    return (

      

      <div className="dashboard">
        <div>
          <div className="dashboard-header">
            <div style={{width: 'calc(100% - 200px)'}}>
              <Progress title={this.props.project.content.information.name} 
                        progression={this.props.project.progression} 
                        kind = "Project"
                        validationInformation = {{...this.props.project.validationInformation,validator:this.props.project.validator}} 
              />
            </div>
            <div style={{flex : 1}}> 
              {route ?
                <Link className="primary-btn filling" style={{float:"right",width:"110px",height:"48px"}} to={route}><ContainerTranslation id={['Page'] + "." + ['ProjectView'] + "." + ['btn-edit']} />
                </Link>
                :
                null
              }
              <ExtractorPowerPoint className="primary-btn" style={{float:"right",width:"156px",height:"48px"}} title={<ContainerTranslation id={['Export'] + "." + ['Extract Button']  } />} projects={this.props.project} translate={this.props.translate} />
            </div>  
          </div>

          <div className="dashboard-content">

            <div className="col-1-3">

              {/*PICTURE*/}
              {this.props.project.picture64 ?
                <img src={this.props.project.picture64} width="100%" alt="consultant" />
                :
                null
              }
              {this.props.project.authorization.picture ?
                <div className="input-container files" style={{ textAlign: 'center', marginTop: '10px' }}>
                  <label htmlFor='picture'>Edit project picture</label>
                  <input type="file"
                    style={{ display: "none" }}
                    onChange={(e) => this.uploadPicture(e.target.files)}
                    id='picture' />
                </div>
              :
                null
              }

              {/*POP UP EXTENSION ERROR*/}
              {this.state.popUpShowExtensionError ?
                <>
                  <Space h="md" />
                  <Notification color="red" title={this.props.translate("feedBack.NotificationPicture.title")} onClose={ () => this.handleClose() }>
                    <Space h="xs" />
                    {this.props.translate("feedBack.NotificationPicture.contexte1")}
                    <Space h="xs" />
                    {this.props.translate("feedBack.NotificationPicture.contexte2")}
                  </Notification>
                </>:
              null}

              {/*INFORMATION*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['information'] + ".title"} tag={"span"} />
                <div className="bloc-content" style={{ marginBottom: 10 }}>
                  {this.props.project.content.information && this.props.project.content.information.isIkos && this.props.project.content.information.isIkos === "true" ?
                    <p className="bloc-tag">IKOS</p>
                    :
                    null
                  }
                  {this.props.project.content.information && this.props.project.content.information.isHSE && this.props.project.content.information.isHSE === "true" ?
                    <p className="bloc-tag">HSE</p>
                    :
                    null
                  }
                  {this.props.project.content.information && this.props.project.content.information.isRSE && this.props.project.content.information.isRSE === "true" ?
                    <p className="bloc-tag">RSE</p>
                    :
                    null
                  }
                </div>
                <p className="bloc-content" style={{ marginBottom: 10 }}>
                  <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['update-date']} /> {this.props.project.updatedAt.slice(0, 10)}
                </p>
                <p className="bloc-content" style={{ marginBottom: 0 }}>
                  <i className="fas fa-user"></i>Consultant
                </p>
                <div className="txt-dark bloc-content" style={{ marginBottom: 10 }}>
                  <Link to={"/consultant/" + this.props.project.user.consultant}>   
                    {this.props.project.user.sageContent.profile.firstName + " " + this.props.project.user.sageContent.profile.lastName }
                  </Link>

                  <p className="bloc-content">
                    <i className="fas fa-map-marker-alt"></i> <ContainerTranslation id={'countries.' + [this.props.project.content.information['filiale-country']]} /> - {this.props.project.content.information['office']}
                  </p>
                </div>
                <p className="bloc-content" style={{ marginBottom: 0 }}>
                  <i className="fas fa-user"></i>Manager
                </p>
                <p className="txt-dark bloc-content" style={{ marginBottom: 10 }}>
                  {this.props.project.content.information.manager ? 
                  <>
                    {this.props.project.content.information.manager}
                  </>:
                  <>
                    <ContainerTranslation id={['Page'] + "." + ['ProjectView']  + "." + ['noManager'] } />
                  </>}
                </p>
                <div style={{ marginTop: '10px' }}>
                  <div style={{ display: 'inline-block' }}>
                    {this.props.project.content.information['start-date']}
                  </div>
                  <div style={{ float: 'right', display: 'inline-block' }}>
                    {this.props.project.content.information['end-date']}
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <div className="dot-date">
                    </div>
                    <div className="line-date">
                    </div>
                    <div className="dot-date">
                    </div>
                  </div>
                </div>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['program'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.information['program']}<br />
                  {this.props.project.content.information['subprogram'] ?
                    <><i className="fas fa-angle-right"></i>{this.props.project.content.information['subprogram']}</>
                    :
                    null
                  }
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['typology'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  <ContainerTranslation id={'typology.' + [this.props.project.content.information['typology']]} /> <br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['information'] + "." + ['phase'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  <ContainerTranslation id={'phases.' + [this.props.project.content.information['phase']]} /> <br />
                </p>
              </div>

              {/*CLIENT*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['client'] + ".title"} tag={"span"} />

                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  client logo
                </p>

                {this.props.project.content.client.picture64 ?
                <img src={this.props.project.content.client.picture64} width="100%" alt="consultant" />
                :
                null
              }

                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  {this.props.project.content.client['level_1'] ? this.props.project.content.client['level_1']['name'] : null}
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.client['level_1'] ? this.props.project.content.client['level_1']['value'] : null}<br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  {this.props.project.content.client['level_2'] ? this.props.project.content.client['level_2']['name'] : null }
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.client['level_2'] ? this.props.project.content.client['level_2']['value'] : null}<br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  {this.props.project.content.client['level_3'] ? this.props.project.content.client['level_3']['name'] : null}
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.client['level_3'] ? this.props.project.content.client['level_3']['value'] : null}<br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  {this.props.project.content.client['level_4'] ? this.props.project.content.client['level_4']['name'] : null}
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.client['level_4'] ? this.props.project.content.client['level_4']['value'] : null}<br />
                </p>
                <p className="bloc-content">
                  <i className="fas fa-user"></i> {this.props.project.content.client.supervisor}
                </p>
                <p className="bloc-content">
                  <i className="fas fa-map-marker-alt"></i> {this.props.project.content.client['localisation-client-country']} - {this.props.project.content.client['localisation-client-cp']}
                </p>
                <div className="bloc-separator">
                </div>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['client'] + "." + ['localisation-deploiement-country'] + ".title"} />
                </p>
                <p className="bloc-content">
                  <i className="fas fa-map-marker-alt"></i> {this.props.project.content.client['localisation-deploiement-country']} - {this.props.project.content.client['localisation-deploiement-cp']}
                </p>
              </div>

              {/*TOOLS*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['tools'] + ".title"} tag={"span"} />
                {this.props.project.content.tools.map(tool => <p className="bloc-tag" key={Date.now() + "-" + tool}>
                  {tool}
                </p>)}
              </div>

              {/*QuaterlyReport*/}
              <div>

                  <>
                    <div className="bloc">
                      <span>{this.props.project.quaterlyReports.length} {this.props.translate("quaterlyReport.list.title")}</span>
                      <QuaterlyReportList itemList={this.props.project.quaterlyReports} />
                    </div>
                  </>
    
                  {( this.props.project.authorization.addQuaterlyReport ) ?
                    <div className="bloc-content" style={{ color: '#181E23', display: 'flex', justifyContent: 'center' }}>
                      <button
                        className="primary-btn"
                        onClick={this.props.createQuaterlyReport.bind(this)}>
                        <ContainerTranslation id={'quaterlyReport.list.button'} />
                      </button>
                    </div>
                    :
                    null
                  } 
              </div>
            </div>


            {/*LEFT PART*/}

            <div className="col-2-3">

              {/*OPERATIONNAL*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['intervention-level'] + ".title"} tag={"span"} />
                {this.props.project.content['intervention-level'].map((intervention, i) => {
                  if (!intervention) {return null}

                  const level_1 = this.props.translate(`intervention-type.${intervention['intervention-type']}`);
                  const level_2 = intervention['intervention-type'] ? this.props.translate(`intervention-mission.${intervention['intervention-type']}.${intervention['intervention-mission']}`) : "";
                  const level_3 = intervention['intervention-type'] && intervention['intervention-mission'] ? this.props.translate(`intervention-application.${intervention['intervention-mission']}.${intervention['intervention-application']}`) : "";
                  const level_4 = intervention['intervention-type'] && intervention['intervention-mission'] && intervention['intervention-application'] ? intervention['level-4'] : "";
                  const fullPath = [level_1,level_2,level_3,level_4].filter((x)=> x);


                  return(
                    <div key={Date.now() + "-" + intervention + i} 
                        style={{ width: '90%', 
                                display: 'block' , 
                                borderWidth:'0px', 
                                borderStyle:'solid', 
                                borderColor:'black' , 
                                marginBlock :'30px',
                                marginInline :'auto' }}>
                        <p className="bloc-content" title={fullPath.join(' > ')}>
                              {this.truncate(fullPath).join(' > ')}
                        </p>
                    </div>
                  )
                })}
              </div>

              {/*ENVIRONNEMENT*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['environnement'] + ".title"} tag={"span"} />
                {this.props.project.content.environnement['environnement-domain'].map(tool => <div key={Date.now() + "-" + tool} style={{ display: 'inline-block' }}>
                  {tool === 'Railway' ?
                    <p className="bloc-tag" style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
                      <i className="fas fa-train" style={{ marginRight: "10px" }}></i><ContainerTranslation id={['secteur'] + "." + [tool]} />
                    </p>
                    :
                    null
                  }
                  {tool === 'Energy' ?
                    <p className="bloc-tag" key={Date.now() + "-" + tool} style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
                      <i className="fas fa-plug" style={{ marginRight: "10px" }}></i>{tool}
                    </p>
                    :
                    null
                  }
                </div>)}
                {this.props.project.content.environnement['environnement-context'].map(tool => <p className="bloc-tag" key={Date.now() + "-" + tool} style={{ backgroundColor: '#52BCC2', color: '#ffffff' }}>
                  <ContainerTranslation id={['context'] + "." + [tool]} />
                </p>)}
              </div>

              {/*TECHNICAL_SKILLS*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['expertise'] + ".title"} tag={"span"} />
                {this.props.project.content['expertise'].map((expertise, i) => {
                  if (!expertise) {return null}
                  const level_1 = this.props.translate(`domain-competence.${expertise['domain-competence']}`);
                  const level_2 = expertise['domain-competence'] ? this.props.translate(`intervention-mission.${expertise['domain-competence']}.${expertise['domain-speciality']}`) : "";
                  const level_3 = expertise['domain-competence'] && expertise['domain-speciality'] ? this.props.translate(`domain-specificity.${expertise['domain-speciality']}.${expertise['domain-specificity']}`) : "";
                  const fullPath = [level_1,level_2,level_3].filter((x)=> x);


                  return (
                          <div key={Date.now() + "-" + expertise + i} 
                          style={{ width: '90%', 
                                  display: 'block' , 
                                  borderWidth:'0px', 
                                  borderStyle:'solid', 
                                  borderColor:'black' , 
                                  marginBlock :'30px',
                                  marginInline :'auto' }}>
                            <p className="bloc-content" title={fullPath.join(' > ')}>
                              {this.truncate(fullPath).join(' > ')}
                            </p>
                          </div>
                    )
                  }
                )}
              </div>

              {/*ENGINEERING-SKILLS*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['engineering'] + ".title"} tag={"span"} />
                {this.props.project.content['engineering'] && this.props.project.content['engineering'].length > 0 ?
                  this.props.project.content['engineering'].map((skill, i) => {

                    if (!skill) {return null}
                    const level_1 = this.props.translate(`engineering-skill.${skill['engineering-skill']}`);
                    const level_2 = skill['engineering-skill'] ? this.props.translate(`engineering-specialization.${skill['engineering-skill']}.${skill['engineering-specialization']}`) : "";
                    const fullPath = [level_1,level_2].filter((x)=> x);

                    return (
                        <div key={Date.now() + "-" + skill + i} 
                            style={{ width: '90%', 
                                    display: 'block' , 
                                    borderWidth:'0px', 
                                    borderStyle:'solid', 
                                    borderColor:'black' , 
                                    marginBlock :'30px',
                                    marginInline :'auto' }}>
                            <p className="bloc-content">
                                {this.truncate(fullPath).join(' > ')}
                            </p> 
                        </div>
                    )

                  })
                  :
                  null
                }
              </div>

              {/*NOTES*/}
              <div className="bloc">
                <ContainerTranslation id={['content'] + "." + ['notes'] + ".title"} tag={"span"} />
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['notes'] + "." + ['keywords'] + ".title"} />
                </p>
                <div className="bloc-content" style={{ color: '#181E23' }}>
                  {typeof this.props.project.content.notes['keywords'] === "object" ?
                    <>{this.props.project.content.notes['keywords'].map(word => <p className="bloc-tag" key={Date.now() + "-" + word}> {word}</p>)}</>
                    :
                    <>{this.props.project.content.notes['keywords']}<br /></>
                  }
                </div>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['notes'] + "." + ['objectives'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.notes['objectives']}<br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['notes'] + "." + ['implementation'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.notes['context']}<br />
                </p>
                <p className="bloc-title" style={{ marginBottom: 0 }}>
                  <ContainerTranslation id={['content'] + "." + ['notes'] + "." + ['results'] + ".title"} />
                </p>
                <p className="bloc-content" style={{ color: '#181E23' }}>
                  {this.props.project.content.notes['activity']}<br />
                </p>
              </div>

            
            </div>

            {/*RIGHT PART*/}


          </div>
        </div>

      </div>

    )
  }
}

const mapStateToProps = state => ({
  project: state.project.project,
  message: state.project.message,
  quaterlyReportMessage: state.quaterlyReport.message,
  quaterlyReport: state.quaterlyReport.quaterlyReport
})

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchProject,
  uploadPicture,
  createQuaterlyReport
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(withLocalize(ProjectView)));
